<template>
  <div class="main">

    <div class="banner" :style="bannerStyle">
   
    
        <!-- <div class="title">专为RWA通证化设计的区块链基础设施</div> -->
       <!--<div class="banner-title">{{ $t('home.theme') }}</div>--> 

        <div style="margin-top: 100px;">
          <div class="content">{{$t('home.advantage[0]')}}</div>
          <!--<div class="content">{{$t('home.advantage[1]')}}</div>-->
        </div>

       

     

    
    <img
      v-if="langue === 'zh'"
      :src="require('../assets/background/bannercn2.png')"
      alt="banner-cn"
      class="banner-overlay"
    />
    <img
      v-else
      :src="require('../assets/background/banneren2.png')"
      alt="banner-en"
      class="banner-overlay"
    />
    </div>

    <Board></Board>

    <div class="containt1">
    <div class="core">
      <div class="core-icon">
        <img :src="require('../assets/home/core/core.png')" alt="" />
      </div>

      <div class="core-content">
        <div class="core-title">
          {{ $t('home.core.title') }}
        </div>
        <div class="core-item" v-for="(item, index) in core" :key="index">
          <div class="circle">{{ index + 1 }}</div>
          <div class="text">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-content">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="statistic">
      <div class="title">{{ $t('home.statistic.title') }}</div>
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin: 0 auto 40px;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
      <div class="statistic-content">
        <div class="statistic-item" v-for="(item, index) in statistic" :key="index">
          <div class="item-icon">
            <img :src="item.icon" alt="">
          </div>
          <div class="item-text">{{ item.text }}(24H)</div>
          <div class="item-value">{{ index === 3 ? ('$' + item.value) : item.value }}</div>
          <div class="item-percent">{{ formatMoM(item.value, item.value24) }}</div>
        </div>
      </div>
    </div>
    <div class="market">
      <!-- market content -->
      <div class="title">{{ $t('home.market.title') }}</div>
      <!-- 插入表格图片，居中显示 -->
      
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin:0 auto;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
      <div style="display: flex; justify-content: center; margin: 80px 0 20px 0; padding: 0 20px;">
        <div class="market-table-container" :style="{ maxHeight: marketTableMaxHeight + 'px' }">
          <table ref="marketTable" class="market-table" style="border-collapse: separate; border-spacing: 2px; width: 100%; max-width: 1200px;">
            <thead class="market-thead">
              <tr>
                <th v-for="(header, index) in tableHeaders" :key="`head-${index}`" style="padding: 14px; text-align: center; color: #bebdbd70 ; font-family: Arial, sans-serif; border: 1px solid   #83818179; font-size: 24px;">{{header}}</th>
              </tr>
            </thead>
            <tbody class="market-tbody">
              <tr v-for="(row, rowIndex) in tableData" :key="`row-${rowIndex}`">
                <td
                  v-for="(cell, cellIndex) in row"
                  :key="`cell-${rowIndex}-${cellIndex}`"
                  style="padding: 15px; text-align: center; border: 1px solid   #83818179;"
                  :style="cellIndex === tableHeaders.length - 1 ? { color: getChangeColor(cell) } : { color: '#fff' }"
                >{{cell}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
    <div class="globalpoint">
      <!-- globalpoint content -->
      <div class="search_box">
        <div style="display: flex; align-items: center; gap: 10px;">
            <div class="search">{{ $t('home.globalpoint.search_title') }}</div>
            <div class="search-icon" style="display: inline-block;"></div>
          </div>
        <div class="menu">
          <span class="menu-item">{{ $t('home.globalpoint.item1') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item2') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item3') }}</span>
         
        </div>
        <div class="table vote-scroll" style="margin: -25px auto 0 auto; height: 700px; width: 90%; overflow-y: scroll; padding-right: 12px; background-color: transparent; scrollbar-gutter: stable;">
          <table style="width: 100%; height: 100%; border-collapse: collapse;">
            <tbody>
              <!-- 用接口数据渲染所有数据；通过外层容器滚动，页面上最多显示 ~10 行 -->
              <tr v-for="(item, index) in voteTop" :key="item.srAddress">
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 80px',
                    color: 'white',
                    fontSize: '18px',
                    width: '20%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ index + 1 }}
                </td>
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 120px',
                    color: 'white',
                    fontSize: '16px',
                    width: '20%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ abbreviateAddress(item.srAddress) }}
                </td>
                <td
                  :style="{
                    borderTop: index === 0 ? 'none' : '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '10px 10px 10px 105px',
                    color: 'white',
                    fontSize: '16px',
                    width: '40%',
                    height: '65px',
                    verticalAlign: 'middle'
                  }"
                >
                  {{ item.voteNum }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
      </div>
      <div class="title">{{ $t('home.globalpoint.title') }}</div>
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin-top: 0;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰" >
      </div>
      
      <img :src="require('../assets/global/picture.png')" alt="图片" style="display: block; position: relative; top: 80px; right: -1100px; scale: 1;">
      
      <div class="global_title">{{ $t('home.globalpoint.global_title') }}</div>
    
        <div class="google">
          <div class="google-play" style="display: inline-block;  text-align: left;">
            <img src="../assets/global/google-play.png" style="display: inline-block; vertical-align: middle; margin-right: 20px;" alt="Google Play" />
            <span style="vertical-align: middle; text-align: left;">GooglePlay</span>
          </div>
          <div class="android" style="display: inline-block; text-align: left;">
            <img src="../assets/global/android.png" style="display: inline-block; vertical-align: middle; margin-right: 20px;" alt="Android" />
            <span style="vertical-align: middle; text-align: left;">Android</span>
          </div>
        </div>
        
      
      <div class="download-container">
      <div class="download">{{ $t('home.globalpoint.download') }}</div>
      <div class="BITW">BIT Wallet</div>
      </div>
    </div>
    </div>


    <div class="member">
      <div class="member_contain">
      <div class="title">{{ $t('home.member.title') }}</div>
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin-top: 0;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>

      <div class="menber-container">
        <div class="member-list">
          <div class="member-list-track" :style="{ transform: `translateY(-${thumbOffset}px)`, transition: isSliding ? 'transform 0.5s ease' : 'none' }">
            <div
              class="member-item"
              v-for="(url, idx) in visibleThumbs"
              :key="idx"
              @click="selectMemberUrl(url, idx)"
              :style="{ backgroundImage: `url(${url})` }"
            ></div>
          </div>
        </div>

        <div class="member-detail">
          
        </div>
      </div>
      </div>
    </div>

    <div class="background2">
        <div class="future">
     
      
      <!-- future content -->
     <div class="futuretitle">{{ $t('home.future.title') }}</div>
    <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin-top: 0;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
    <div class="future_container"></div>
      <div class="future_title2" @click="scrollTimeline(1)">{{ $t(`home.future.time.${selectedTimelineIndex}`) }}</div>
      <div class="future_content">{{ $t(`home.future.content${selectedTimelineIndex + 1}`) }}</div>
      <div class="line"></div>
      <div class="future_picture" :style="{ backgroundImage: getFutureImagePath(selectedTimelineIndex) }"></div>
      <div
        class="future_arrow_left"
        :class="{ disabled: !canScrollLeft }"
        @click="scrollTimeline(-1)"
        @dblclick.stop.prevent
      ></div>
      <div class="future_timeline"></div>
      <div
        class="future_arrow_right"
        :class="{ disabled: !canScrollRight }"
        @click="scrollTimeline(1)"
        @dblclick.stop.prevent
      ></div>
      
      <!-- 虚线标记点 - 使用实际图片元素 -->
       
      <div 
        v-for="(item, index) in displayTimelineItems" 
        :key="item.index"
        :class="['timeline_marker', `marker_${index + 1}`]"
      >
        <img src="../assets/future/fenge.png" :alt="`Marker ${index + 1}`">        
      </div>
      
      <div 
        v-for="(item, index) in displayTimelineItems" 
        :key="`date-${item.index}`"
        :class="['timeline_date', `date_${index + 1}`, { active: selectedTimelineIndex === item.index }]"
        @click="handleTimelineClick(item.index)"
      >
        {{ item.time }}
      </div>
       <div class="timeline_marker1_container" :style="{ marginLeft: markerPosition }">
      </div>
    
  </div>
  
  <div class="BITdonate">
    <!-- BITdonate content -->
    
    <!-- 左右布局 - 图片在左侧，文本在右侧 -->
    <div class="BITplan-image">
      <img :src="require('../assets/background/BITplan.png')" alt="BIT计划" >
    </div>
    <div class="BITdonate-content">
      <div class="BITdonate-title">{{ $t('home.BITdonate.title') }}</div>
      <div class="title2">{{ $t('home.BITdonate.title2') }}</div>
      <div class="content3">BRC20:<br> <br>BB4QTLuLuAUt6oQ8Gvczk8uDEo62kwrFQP</div>
      <div class="content4">{{ $t('home.BITdonate.content4') }}</div>
    </div>
    
  </div>
  
  <div class="RWAcooperate">
    <!-- RWAcooperate content -->
    <div class="title">{{ $t('home.RWAcooperate.title') }}</div>
    <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin: 0 auto;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰">
      </div>
    <div class="image-grid">
      <div v-for="index in 8" :key="index" class="grid-image" :style="index === 1 ? { backgroundImage: `url(${require('../assets/home/KW.png')})` } : (index === 2 ? { backgroundImage: `url(${require('../assets/home/ACG.png')})` } : {})">
    </div>
  </div>
  </div>
  </div>
  </div>

</template>

<script>
import Board from '@/components/Board.vue'
import { homeData, stylePhotosList, allTicker, bitUsdtPrice, parseBitUsdtPrice, voteRealPage } from '@/api';

export default {
  name: 'Home',
  components: { Board },
  computed: {
    // 计算当前显示的时间点列表
    displayTimelineItems() {
      // 获取当前应该显示的7个时间点
      const allTimelineItems = this.$t('home.future.time');
      const start = this.timelineStartIndex;
      const end = Math.min(start + 7, allTimelineItems.length);
      
      return allTimelineItems.slice(start, end).map((time, index) => ({
        time,
        index: start + index
      }));
    },
    // 计算标记位置：按虚线的八等分落点居中对齐
    markerPosition() {
      // 预设位置数组（与当前显示窗口的7个槽位对应）
      const positions = ['-490.5px', '-338.5px', '-188.5px', '-37px', '114.5px', '266px', '417.5px'];
      const relativeIndex = this.selectedTimelineIndex - this.timelineStartIndex;
      // 右移微调量（可按需微调，比如 8~14 像素）
      const offset = 12;

      const idx = relativeIndex >= 0 && relativeIndex < 7 ? relativeIndex : 0;
      const base = parseFloat(positions[idx]) || 0;
      return `${base + offset}px`;
    },
    bannerStyle() {
      const bg = require('../assets/background/bannerbackground.png');
      return {
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    },
    // 新增：是否可以向左/向右滚动
    canScrollLeft() {
      return this.selectedTimelineIndex > 0;
    },
    canScrollRight() {
      const total = this.$t('home.future.time').length;
      return this.selectedTimelineIndex < total - 1;
    },
    visibleThumbs() {
      const urls = this.stylePhotoUrls || [];
      if (!urls.length) return [];
      const start = this.thumbStartIndex % urls.length;
      return [0,1,2,3].map(i => urls[(start + i) % urls.length]);
    }
  },
  data() {
    return {
      langue: localStorage.getItem('langue'),
      loading: {
        transaction: false,
        vote: false,
        token: false,
      },
      banners: [],
      selectedTimelineIndex: 0,
      timelineStartIndex: 0, // 当前显示的时间点起始索引
      stylePhotoUrls: [],
      thumbStartIndex: 0,
      thumbOffset: 0,
      thumbStep: 185,
      isSliding: false,
      slideDuration: 500,
      // 表格数据定义
      tableHeaders: [
        this.$t('tablehaead.item1'),
        this.$t('tablehaead.item2'),
        this.$t('tablehaead.item7'),
        this.$t('tablehaead.item8'),
      ],
      tableData: [],
      visibleRows: 7,
      marketTbodyMaxHeight: 0,
      marketTableMaxHeight: 0, // 新增：容器总高度（表头 + 内容）
      voteTop: [], // 新增：投票排行榜数据

      
      core: [
        {
          // img: require('../assets/home/core/open.png'),
          title: this.$t('home.core.open.title'),
          content: this.$t('home.core.open.content'),
        },
        {
          // img: require('../assets/home/core/decent.png'),
          title: this.$t('home.core.decent.title'),
          content: this.$t('home.core.decent.content'),
        },
        {
          // img: require('../assets/home/core/pledge.png'),
          title: this.$t('home.core.pledge.title'),
          content: this.$t('home.core.pledge.content'),
        },
      ],

      statistic: [
        {
          icon: require('../assets/home/statistic/accountCount.png'),
          text: this.$t('home.statistic.accountCount'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/home/statistic/transactionCount.png'),
          text: this.$t('home.statistic.transactionCount'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/home/statistic/voteCount.png'),
          text: this.$t('home.statistic.voteCount'),
          value: '',
          value24: '',
        },
        {
          icon: require('../assets/home/statistic/tokenCount.png'),
          text: this.$t('home.statistic.tokenCount'),
          value: '',
          value24: '',
        }
      ],
      statisticCount: {
        node: '',
        contract: '',
        token: '',
      },
      members: [
        [
          {
            // img: require('../assets/home/member/tommy.png'),
            name: this.$t('home.member.tommy.name'),
            position: this.$t('home.member.tommy.position'),
            describe: this.$t('home.member.tommy.describe'),
            describe1: this.$t('home.member.tommy.describe1'),
            left: true,
            bg: require('../assets/member/1.png')
          },
          {
            // img: require('../assets/home/member/lius.png'),
            name: this.$t('home.member.lucius.name'),
            position: this.$t('home.member.lucius.position'),
            describe: this.$t('home.member.lucius.describe'),
            left: true,
            bg: require("../assets/member/2.png")
          },
          {
            // img: require('../assets/home/member/mark.png'),
            name: this.$t('home.member.mark.name'),
            position: this.$t('home.member.mark.position'),
            describe: this.$t('home.member.mark.describe'),
            left: false,
            bg: require("../assets/member/3.png")
          }
        ],
       
      ],

      activeMember: {},
      carouselIndex: 0,
      carouselTimer: null,
      // 时间轴相关状态
    }
  },
  mounted() { 
    this.loadStylePhotos(0).then(() => {
      const list = this.stylePhotoUrls || [];
      if (list.length) {
        this.restartMemberCarouselFrom(0);
      }
    });
    this.$nextTick(() => this.ensureMarketScrollHeight());
  },
  destroyed() { this.stopMemberCarousel(); },
  async created() {
    // deal banner
    this.banners.push({ img: this.langue === 'zh' ? require('../assets/home/banner/banner1.png') : require('../assets/home/banner/banner1-en.png'), });
    // this.banners.push({ img: this.langue === 'zh' ? require('../assets/home/banner/banner2.png') : require('../assets/home/banner/banner2-en.png'), });
    // this.banners.push({ img: this.langue === 'zh' ? require('../assets/home/banner/banner3.png') : require('../assets/home/banner/banner3-en.png'), });

    this.statisticData();
    // 设置一个安全默认高度，避免DOM测量失败时看起来没有内容
    // 安全默认值（行高约56px）
    this.marketTbodyMaxHeight = 56 * this.visibleRows;
    this.marketTableMaxHeight = this.marketTbodyMaxHeight + 40; // 40 作为表头高度默认值
    this.loadMarketData();
    this.loadVoteTop(); // 加载全球节点搜索数据

    this.activeMember = this.members[0][0];
  },
  methods: {
    // 处理时间点点击事件
    handleTimelineClick(index) {
      this.selectedTimelineIndex = index;
    },
    
    // 切换到下一个时间点
    nextTimelineItem() {
      const timelineCount = this.$t('home.future.time').length;
      this.selectedTimelineIndex = (this.selectedTimelineIndex + 1) % timelineCount;
    },
    
    // 获取未来时间点的图片路径
    getFutureImagePath(index) {
      // 处理动态图片路径加载
      const imageNumber = index + 1;
      try {
        // 尝试加载对应的图片并格式化为backgroundImage所需的url()格式
        if (index === 0) {
          return `url(${require('../assets/future/1.png')})`;
        } else {
          // 对于其他图片，使用jpg格式，确保能处理1-14个时间点
          return `url(${require(`../assets/future/${imageNumber}.jpg`)})`;
        }
      } catch (error) {
        console.error(`Failed to load image for timeline index ${index}:`, error);
        // 如果图片加载失败，返回第一个图片作为默认值
        return `url(${require('../assets/future/1.png')})`;
      }
    },
    async loadVoteTop() {
      try {
        const res = await voteRealPage();
        // 兼容返回结构：{ total, data: [...] }
        const list = res && res.data && Array.isArray(res.data)
          ? res.data
          : (res && res.data && res.data.data && Array.isArray(res.data.data) ? res.data.data : []);
        this.voteTop = list;
      } catch (e) {
        console.error('loadVoteTop failed:', e);
        this.voteTop = [];
      }
    },
    

    
    async statisticData() {
      await homeData().then(res => {
        if (res.code != 0) {
          return;
        }
        this.statistic[0].value = res.data.account;
        this.statistic[0].value24 = res.data.account24;

        this.statistic[1].value = res.data.transaction;
        this.statistic[1].value24 = res.data.transaction24;

        this.statistic[2].value = res.data.vote;
        this.statistic[2].value24 = res.data.vote24;

        this.statistic[3].value = res.data.token;
        this.statistic[3].value24 = res.data.token24;

        this.statisticCount.node = res.data.totalNode;
        this.statisticCount.contract = res.data.totalContract;
        this.statisticCount.token = res.data.token;
      });
    },
    async loadMarketData() {
      try {
        const [tickerRes, bitPriceRes] = await Promise.all([allTicker(), bitUsdtPrice()]);
        const raw = typeof tickerRes === 'string' ? (() => { try { return JSON.parse(tickerRes) } catch { return {} } })() : tickerRes;
        let list = [];
        if (Array.isArray(raw)) list = raw;
        else if (Array.isArray(raw?.data)) list = raw.data;
        else if (Array.isArray(raw?.data?.list)) list = raw.data.list;
        else if (Array.isArray(raw?.list)) list = raw.list;
        else {
          const candidates = [
            ...Object.values(raw || {}).filter(Array.isArray),
            ...Object.values((raw || {}).data || {}).filter(Array.isArray),
          ];
          if (candidates.length) list = candidates.flat();
          else {
            const values = Object.values((raw?.data ?? raw) || {});
            const looksLikeTicker = item => item && (item.market || item.symbol || item.pair) && (item.last !== undefined || item.price !== undefined || item.close !== undefined);
            list = values.filter(looksLikeTicker);
          }
        }
        const bitPrice = parseBitUsdtPrice(bitPriceRes);
        this.tableData = list.map(item => {
          const market = String(item?.market ?? item?.symbol ?? item?.pair ?? '').toUpperCase();
          const symbol = market.replace(/USDT$/i, '');
          const last = symbol === 'BIT' ? bitPrice : (item?.last ?? item?.price ?? item?.close ?? '');
          const volume = item?.volume ?? item?.vol ?? '';
          const change = item?.priceChangePercent ?? item?.changePercent ?? item?.pct ?? '';
          return [symbol, `${last}`, `${volume}`, change === '' ? '' : `${change}%`];
        });

        // 渲染后再测量行高，更新滚动区域高度
        this.$nextTick(() => this.ensureMarketScrollHeight());
        console.log('Loaded market rows:', this.tableData.length);
      } catch (e) {
        console.error('Failed to load market data:', e);
      }
    },
    
    updateMarketTableMaxHeight() {
      const table = this.$refs && this.$refs.marketTable ? this.$refs.marketTable : null;
      if (!table) return;
      const thead = table.querySelector('thead');
      const tbody = table.querySelector('tbody');
      const firstRow = tbody ? tbody.querySelector('tr') : null;
      const theadHeight = thead ? thead.offsetHeight : 0;
      const rowHeight = firstRow ? firstRow.offsetHeight : 0;
      if (rowHeight > 0) {
        this.marketTableMaxHeight = theadHeight + rowHeight * this.visibleRows;
      }
    },

    ensureMarketScrollHeight() {
      const table = this.$refs && this.$refs.marketTable ? this.$refs.marketTable : null;
      if (!table) return;
      const tbody = table.querySelector('tbody');
      const thead = table.querySelector('thead');
      const firstRow = tbody ? tbody.querySelector('tr') : null;
      const rowHeight = firstRow ? firstRow.getBoundingClientRect().height : 56;
      const headerHeight = thead ? thead.getBoundingClientRect().height : 40;

      this.marketTbodyMaxHeight = Math.round(rowHeight * this.visibleRows);
      this.marketTableMaxHeight = Math.round(headerHeight + this.marketTbodyMaxHeight);
    },

    selectMember(member) {
      this.activeMember = member;
      this.selectedMemberBg = '';
      setTimeout(() => {
        const memberDetail = document.querySelector('.member-detail');
        if (memberDetail) {
          let detailImgPath = '';
          const memberIndex = this.members[0].findIndex(m => m.bg === member.bg);
          if (memberIndex === 0) {
            detailImgPath = require('../assets/member/1-1.png');
          } else if (memberIndex === 1) {
            detailImgPath = require('../assets/member/2-2.png');
          } else if (memberIndex === 2) {
            detailImgPath = require('../assets/member/3-3.png');
          }
          memberDetail.style.cssText += `
            background-image: url('${detailImgPath}') !important;
            background-size: 100% 100% !important;
            background-repeat: no-repeat !important;
            background-position: center !important;
          `;
          this.restartMemberCarouselFrom(memberIndex);
        }
      }, 0);
    },
    
    // 处理时间轴滚动事件
    scrollTimeline(direction) {
      const allTimelineItems = this.$t('home.future.time');
      const totalItems = allTimelineItems.length;

      // 计算新的选中索引（不循环，越界直接返回）
      const newSelectedIndex = this.selectedTimelineIndex + direction;
      if (newSelectedIndex < 0 || newSelectedIndex >= totalItems) {
        return; // 到边界，不动作
      }

      // 计算新的窗口起始索引（保持选中项在窗口中，且不越界）
      let newStartIndex = this.timelineStartIndex + direction;
      const maxStart = Math.max(0, totalItems - 7);
      if (newStartIndex < 0) newStartIndex = 0;
      if (newStartIndex > maxStart) newStartIndex = maxStart;

      this.timelineStartIndex = newStartIndex;
      this.selectedTimelineIndex = newSelectedIndex;
    },
    getChangeColor(cell) {
      const n = Number(String(cell).replace('%', '').trim());
      if (Number.isNaN(n)) return '#fff';      // 非数值时保持默认白色
      return n >= 0 ? '#03d50e' : '#ff4d4f';   // ≥0 绿色，<0 红色
    },
    formatMoM(current, prev) {
      const c = Number(current);
      const p = Number(prev);
      if (!isFinite(c) || !isFinite(p)) return '';
      if (p === 0) return '0%';
      const ratio = ((c - p) / p) * 100;
      return `${ratio.toFixed(0)}%`;
    },
    abbreviateAddress(addr) {
      if (!addr || typeof addr !== 'string') return '';
      const head = addr.slice(0, 5);
      const tail = addr.slice(-5);
      return `${head}···${tail}`;
    },
    startMemberCarousel() {
      this.stopMemberCarousel();
      const list = this.stylePhotoUrls || [];
      if (!list.length) return;
      this.carouselIndex = this.carouselIndex % list.length;
      this.carouselTimer = setInterval(() => {
        this.isSliding = true;
        this.thumbOffset = this.thumbStep;
        setTimeout(() => {
          this.isSliding = false;
          this.carouselIndex = (this.carouselIndex + 1) % list.length;
          this.thumbStartIndex = this.carouselIndex;
          this.updateMemberDetailByUrl(list[this.carouselIndex]);
          this.thumbOffset = 0;
        }, this.slideDuration);
      }, 2000);
    },
    restartMemberCarouselFrom(index) {
      const list = this.stylePhotoUrls || [];
      if (!list.length) return;
      this.carouselIndex = Math.max(0, Math.min(index || 0, list.length - 1));
      this.thumbStartIndex = this.carouselIndex;
      this.stopMemberCarousel();
      this.updateMemberDetailByUrl(list[this.carouselIndex]);
      this.carouselTimer = setInterval(() => {
        this.isSliding = true;
        this.thumbOffset = this.thumbStep;
        setTimeout(() => {
          this.isSliding = false;
          this.carouselIndex = (this.carouselIndex + 1) % list.length;
          this.thumbStartIndex = this.carouselIndex;
          this.updateMemberDetailByUrl(list[this.carouselIndex]);
          this.thumbOffset = 0;
        }, this.slideDuration);
      }, 2000);
    },
    stopMemberCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    selectMemberUrl(url, idx) {
      const list = this.stylePhotoUrls || [];
      const absIndex = ((this.thumbStartIndex || 0) + (idx || 0)) % (list.length || 1);
      this.restartMemberCarouselFrom(absIndex);
    },
    updateMemberDetailByUrl(url) {
      setTimeout(() => {
        const memberDetail = document.querySelector('.member-detail');
        if (memberDetail && url) {
          memberDetail.style.cssText += `
            background-image: url('${url}') !important;
            background-size: 100% 100% !important;
            background-repeat: no-repeat !important;
            background-position: center !important;
          `;
        }
      }, 0);
    },
    async loadStylePhotos(category = 0) {
      try {
        const res = await stylePhotosList(category);
        const data = res?.data ?? res;
        const urls = data?.result?.photoUrl || data?.data?.photoUrl || data?.photoUrl || [];
        const mapped = (urls || []).map(u => this.normalizePhotoUrl(String(u || ''))).filter(Boolean);
        this.stylePhotoUrls = mapped;
        this.thumbStartIndex = 0;
        if (this.stylePhotoUrls.length) {
          this.updateMemberDetailByUrl(this.stylePhotoUrls[0]);
          this.startMemberCarousel();
        } else {
          this.stopMemberCarousel();
        }
      } catch (e) {
        console.error('loadStylePhotos failed:', e);
        this.stylePhotoUrls = [];
        this.thumbStartIndex = 0;
        this.stopMemberCarousel();
      }
    },
     normalizePhotoUrl(url) {
      const cleaned = String(url || '').trim().replace(/^[`'"]+|[`'"]+$/g, '').replace(/\s+/g, '');
      if (!cleaned) return '';
      if (/^https?:\/\//i.test(cleaned)) return cleaned;
      const base = process.env.VUE_APP_NEWS_API_BASE || 'http://192.168.56.109:9016';
      const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
      const rel = cleaned.startsWith('/') ? cleaned : `/${cleaned}`;
      
      
      return `${prefix}${rel}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  // margin-left: 60px;
  // width: 70%;
  // min-width: 1000px;
  // margin-right: 80px;
  width: 100%;
  margin-top: 50px;
 

  .banner {
    position: relative; /* 作为覆盖图的定位上下文 */
    height: 576px;
    
    margin-bottom: 0px;
    padding-top: 50px;
    
 

    /* 背景图片通过动态样式设置 */
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%; /* 确保图片完全填充div */
     /* 可选：固定背景图片位置 */
    width: 100%;
    
    
    margin: 0 auto;
    // height: 781px;
    // padding-top: 30px;
   /* .banner-title {
     
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-bottom: 100px;
      
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
     
      letter-spacing: 2px;
    }*/

    


      // flex: 1;
      // max-width: 600px;
      // z-index: 2;
      

      .title {
        color: #ffffff;
        font-size: 60px;
        font-weight: 700;
        line-height: 1.2;
        margin-bottom: 30px;
        font-family: "微软雅黑";
        margin-top: 30px;
       


      }



      .content {
        font-family: "微软雅黑";
        color: #f5f2f2;
        font-size: 28px;
        font-weight: 300;
        text-align: center;
        position: relative;
       
        margin: 0 auto;
        margin-top:360px;
        width: 100%;
        min-width: 600px;
        letter-spacing: 2px;
        

      .content:nth-of-type(3) {
        margin-top: -55px;
        margin-bottom: 18px;
      }
    }


  


  }
  .banner-overlay {
    position: absolute;
    top: 100px;           /* 下移 100px */
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none; /* 避免遮挡交互 */
    /* 可选：设置尺寸，示例为自适应宽度
    max-width: 100%;
    height: auto;
    */
  }

 .containt1{
   background-image: url('../assets/background/background1.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
   width:100%;
 
  position: relative;
 min-width: 600px;
  margin: 0 auto;



  .core {
    
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 32px; /* 调小间距，随宽度自适应 */
    padding-top: 80px; /* 新增：向下移动距离（自适应） */
    height: 750px;
    min-width: 600px;
    
    
    
    margin: 0 auto;

    .core-icon {
      position: relative;
      /* 放大容器宽度，随屏幕自适应（最小 280px，最大 420px） */
      width: 460px;
      height: auto;

      img {
        /* 图片占满容器宽度并保持比例 */
        width: 100%;
        height: auto;
        display: block;
        scale: 0.75;
      }

    }

    .core-content {
      font-family: "微软雅黑";
      position: static;           
      right: auto;                /* 清除右侧偏移 */
      top: 300px;                  /* 清除顶部偏移 */
      min-width: 640px;
      min-height: 400px;
      margin-top: 25px;
      display: flex;
      flex-direction: column;
      color: #fff;


      .core-title {
        font-size: 44px;       /* 标题大小随屏幕缩放 */
        font-weight: 600;
        margin-top: -10px;
      }

      .core-item {
        font-family: "微软雅黑";
        display: flex;
        align-items: flex-start;
         background: rgba(255, 255, 255, 0.05);
        border-radius: 6px;
        padding: 30px;
        margin-bottom: 12px;
        margin-top: 30px;
        color: #fff;
        max-width: 580px;
        max-height: 125px;  

        .circle {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          font-size: 17px;
          border: 1px white solid;
        }

        .text {
          display: flex;
          flex-direction: column;
          width: 450px;

          .item-title {
            font-size: 25px;
            font-weight: 500;
           margin-top: -6px;
          }

          .item-content {
            font-size: 18px;
            margin-top: 6px;
            color: #757677;
            width: 500px;
          }
        }

      }
    }

  }

/* 小屏断点：改为垂直堆叠，避免过大间距 */



  .statistic {
    padding-top: 0px;
    font-size: 14px;
   
    min-width: 600px;
    
    margin: 0 auto;
    height: 550px;

    // justify-content: space-between;

    .title {
      font-size: 44px;
      color: #fff;
      font-size: 700;
      font-family: emoji;
      font-weight: 600;
      text-align: center;
    }

    .statistic-content {
      display: flex;
      margin-top: 75px;
      justify-content: center;

      .statistic-item {
        background-color: rgba(173, 169, 169, 0.062);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        
        height: 260px;
        width: 220px;
        margin:  10px ; /* 居中显示 */
        padding-bottom: 30px;

        .item-icon {
          margin-top: -50px;

          img {
            width: 100px;
            height: 100px;
          }
        }

        .item-text {
          font-family: "微软雅黑";
          font-size: 15px;
          font-weight: 550;
          // margin-top: 6px;
          color: #757677;
        }

        .item-value {
          color: #fff;
          font-size: 25px;

        }

        .item-percent {
          color: #03d50e;
          font-size: 14px;
        }
      }
    }


    .tab+.tab {
      margin-left: 10px;
    }
  }


  .statistic-count {
    margin-top: 10px;
    font-size: 13px;

    span {
      color: #C3A46A;
      margin-right: 20px;
    }
  }
   .market {
    
   

    height: 750px;
   
   
    min-width: 600px;
    width: 100%;
    
    
    margin: 0 auto;


  
    
    .title {
      font-family: "微软雅黑";
      color: #ece6e6;
      //color: #83818179;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      
      text-align: center;
      width: 100%;
    }

    .market-table-container {
      width: min(100%, 1200px); /* 宽度与表格一致 */
      margin: 0 auto;          /* 居中 */
      overflow-y: auto;        /* 滚动条在容器右侧（紧贴最后一列） */
      scrollbar-gutter: stable;/* 预留滚动条空间，避免表头与内容错位 */
      /* Firefox：滚动条颜色（thumb 半透明，轨道透明），不改大小 */
      scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
    }

    /* WebKit：轨道透明、拇指半透明，不改宽度/位置 */
    .market-table-container::-webkit-scrollbar {
      background: transparent;
    }
    .market-table-container::-webkit-scrollbar-track {
      background: transparent;
    }
    .market-table-container::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.35);
      border-radius: 8px;
    }
    .market-table-container::-webkit-scrollbar-thumb:hover {
      background-color: rgba(255, 255, 255, 0.5);
    }

    .market-table {
      width: 100%;
      table-layout: fixed; /* 保持列宽对齐 */
      /* 保留你当前的分隔线样式 */
      border-collapse: separate;
      border-spacing: 2px;
    }

    .market-thead {
      position: sticky;
      top: 0;
      z-index: 1;
      background-color: #1d1c1c; /* 不透明背景色 */
    }

    .market-tbody {
      display: table-row-group; /* 恢复默认布局，取消tbody独立滚动 */
      overflow: visible;
    }
 }
.globalpoint {
    
  

    height: 1181px;
  
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
     
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    
    .title {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      
      text-align: center;
      width: 100%;
    }
    .search_box {
      background-color: rgba(29, 28, 28, 0.76);
      width: 680px;
      height: 885px;
      position: absolute; 
      left: 360px; 
      top: 150px; /* 调整顶部位置，从500px改为100px，使其在可视区域内 */
      z-index: 10; /* 添加z-index确保显示在其他元素上方 */
      .search {
       font-family: "微软雅黑";
       color: #6d6c6c;
       font-size: 20px;
       padding-left: 20px;
       width: 350px;
       padding-top: 10px;
       margin-top: -40px; /* 向上移动30px */
      }
       .table {
    background-color: transparent !important;
    
  }
      .vote-scroll {
    background-color: transparent !important;
    scrollbar-gutter: stable; // 为滚动条在右侧预留空间
    color-scheme: dark;        // 关键：提示浏览器使用深色滚动条主题
    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
  }

  /* Chrome / Edge / Safari — 穿透 scoped 并完全透明化轨道 */
  :deep(.vote-scroll)::-webkit-scrollbar {
    width: 8px;
    background: transparent !important;
  }
  :deep(.vote-scroll)::-webkit-scrollbar-track {
    background: transparent !important;
  }
  :deep(.vote-scroll)::-webkit-scrollbar-track-piece {
    background: transparent !important;
  }
  :deep(.vote-scroll)::-webkit-scrollbar-corner {
    background: transparent !important;
  }
  :deep(.vote-scroll)::-webkit-scrollbar-thumb {
    background: rgba(56, 55, 55, 0.35);
    border-radius: 4px;
  }
    }
    
        .search-icon {
          
          width: 400px; /* 设置宽度 */
          height: 100px; /* 设置高度 */
          
          scale: 1;
          margin-left: 120px; /* 减小右侧距离到10px */
          margin-top: 12px;
          font-size: 20px;
          color: #c2c2c280;
          text-align: center;
          padding-left: 50px;
          padding-top: 15px;
        }
        .menu {
          background-image: url('../assets/global/menu.png');
          background-repeat: no-repeat;
          background-position:  center;
          width: 700px; /* 减小宽度以压缩菜单项 */
          height: 100px; /* 设置高度 */
          font-family: "微软雅黑";
          color: #000000;
          font-size: 18px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: -50px; /* 向上移动30px */
          font-weight: 600;
          margin-left: -10px; /* 向左移动，减小正值或设置为负值 */
        }
        
        .menu-item {
          margin: 0 80px;
          width: auto; /* 自动宽度 */
          white-space: nowrap; /* 确保文字不换行 */
        }
  
    .global_title {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 40px;
      font-weight: 600;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      text-align: right;
      margin-top: 130px;
      right: 450px;
      position: relative;
      
    
    }
    
    .google {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 30px;
      font-weight: 200;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
      text-align: right;
      margin-top: 30px;
      margin-right: 320px;
      .google-play {
        display: inline-block;
        background-image: url('../assets/global/system.png');
        background-size: cover;
        width: 250px;
        
        padding: 20px;
        margin-right: 10px;
      }
      .android {
        display: inline-block;
        background-image: url('../assets/global/system.png');
        background-size: cover;
        width: 200px;
        padding: 20px;
        margin-right: 30px;
        
      }
      
    
    
    }
    .download-container {
      
      display: flex;
      flex-direction: column;
      
      left: 1110px;
      position: relative;
      background-image: url('../assets/global/saomaxiazai.png');
      
      background-repeat: no-repeat;
      margin-top: 50px;
      height: 300px;
      width: 800px;
       /* 宽度拉长20%，高度保持100% */
      
    }
    
      .download {
        font-family: "微软雅黑";
        color: #ece6e6;
        font-size: 32px;
        font-weight: 550;
        line-height: 1.2;
        margin-bottom: 2px;
        font-family: 'Arial', sans-serif;
        text-align: left;
        
        margin-top:30px;
        margin-left: 170px; /* 添加左边距使文本向右移动 */
      }
      .BITW{
        font-family: "微软雅黑";
        color: #ece6e6;
        font-size: 48px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 2px;
        font-family: 'Arial', sans-serif;
        text-align: left;
        
        margin-top: 10px;
        margin-left: 170px; /* 添加左边距使文本向右移动 */
      }
      /* 已在HTML中使用内联样式设置search_box位置 */
  }
 
 }



  .member {

   
    font-size: 14px;
    background-image: url("../assets//home/member/bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: 100%;
   margin: 0 auto;
    position: relative;

    min-width: 600px;
    height: 914px;
    padding-top: 50px;

    .member_contain {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    
    
    .title {
      font-size: 44px;
      color: #fff;
      font-size: 700;
      font-family: emoji;
      font-weight: 600;
      text-align: center;
    }

    .member-detail {
      display: flex;
      background-image: url("../assets/home/member/detailProfile.png");
      width: 800px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 66px;
      position: relative;
      height: 533px;
    }

    .menber-container {
      display: flex;
      justify-content: space-between;
      // height: 100%;
      width: 100%;
      max-width: 1200px;
      // padding: 0 20px;
      box-sizing: border-box;
      align-items: stretch;
      margin: 100px auto;

      .member-list {
        display: flex;
        flex-direction: column;
        justify-content: start;
        overflow: hidden;
        height: 533px;

        .member-list-track {
          display: flex;
          flex-direction: column;
          transition: none;
          will-change: transform;
        }

        .member-item {
          width: 375px;
          height: 163px;
          background-size: cover;
          background-position: center;
          cursor: pointer;
          margin-bottom: 22px;

          box-sizing: border-box;
          padding: 50px;
          font-size: 20px;
        }

        
      }
    }

  }
  }
}
.background2{
  
    background-image: url('../assets/background/background2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
 
    width: 100%;
   
  position: relative;
    
    margin: 0 auto;
    
    padding-top: 50px;
    height: 2149px;
  
}
.future {
    //background-image: url('../assets/background/future.jpg');
    height: 1092px;
    padding: 0 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
    margin-left: calc(-960px + 50%);
   /* position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;*/
    
  }
  

 

  
  
 .futuretitle {
     font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
     
      text-align: center;
      width: 100%;
      padding-top: 100px;

      
    }
    .future_container {
     background-image: url('../assets/future/ditu.png');
  background-repeat: no-repeat;
  /* 保持 1920 画布并居中锚定 */
  position: relative;
  width: 1920px;
  max-width: 1920px;
  min-width: 1920px;
  left: 50%;
  transform: translateX(-960px);
  margin: 100px 0 0;
   flex-direction: column;
    justify-content: center;
    align-items: center;
  height: 691px;
  
    
    }
    .future_title2 {
      font-family: "Verdana, Geneva, sans-serif";
  color: #ffffff;
  font-size: 70px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 20px;
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translateX(-340px);
  z-index: 10;
  text-align: right;
    }
    .future_content{
      font-family: "微软雅黑";
  color: #adacacf6;
  width: 550px;
  position: absolute;
  font-size: 24px;
  top: 470px;
  left: 50%;
  transform: translateX(-610px);
  z-index: 10;
  text-align: justify;
    }
    .line{
      width: 5px;
  height: 125px;
  background-color: #fffffff6;
  position: absolute;
  top: 380px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
    }
    .future_picture{
      background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  width: 470px;
  height: 250px;
  top: 380px;
  left: 50%;
  transform: translateX(70px);
  z-index: 10;

    }
    .future_timeline{
      width: 1210px;
  height: 2px;
  background: repeating-linear-gradient(
    to right,
    #fffffff3,
    #ffffffd2 4px,
    transparent 2px,
    transparent 10px
  );
  border: none;
  background-color: transparent;
  position: absolute;
  left: 50%;
  transform: translateX(calc(-50% - 20px));
  margin-top: -169px;
  z-index: 9;
    }
    
    /* 虚线标记点容器样式 */
.timeline_marker {
  position: absolute;
  margin-top: -178px;
  z-index: 13; /* 提高层级以覆盖虚线 */
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.8); /* 添加半透明背景覆盖虚线 */
}

/* 按虚线的八等分放置（起点=300px，宽度=1210px） */
.marker_1 { margin-left: calc(300px + 1210px * 0.125); } /* 1/8 */
.marker_2 { margin-left: calc(300px + 1210px * 0.25); }  /* 2/8 */
.marker_3 { margin-left: calc(300px + 1210px * 0.375); } /* 3/8 */
.marker_4 { margin-left: calc(300px + 1210px * 0.5); }   /* 4/8 */
.marker_5 { margin-left: calc(300px + 1210px * 0.625); } /* 5/8 */
.marker_6 { margin-left: calc(300px + 1210px * 0.75); }  /* 6/8 */
.marker_7 { margin-left: calc(300px + 1210px * 0.875); } /* 7/8 */
/* 日期文本：同样以中心为锚点设置偏移，并保留原样式 */
.timeline_date {
  position: absolute;
  left: 50%;
  color: #ffffff;
  font-size: 21px;
  font-weight: 800;
  margin-top: -120px;
  z-index: 15;
  text-align: center;
  width: 60px;
  transform: translateX(-33%);
  cursor: pointer;
  transition: all 0.3s ease;
}
.timeline_date.active {}

/* 日期的偏移量（原 margin-left 相对中心的偏移） */
.date_1 { margin-left: -495px; }
.date_2 { margin-left: -340px; }
.date_3 { margin-left: -197px; }
.date_4 { margin-left: -40px; }
.date_5 { margin-left: 110px; }
.date_6 { margin-left: 265px; }
.date_7 { margin-left: 420px; }

/* 时间标尺容器 */
.timeline_marker1_container{
  background-image: url('../assets/future/time.png');
  background-size: 100%;
  background-repeat: no-repeat;
  z-index: 14;
  position: absolute;

  /* 以画布中心为锚点，固定到 1920 设计稿坐标 */
  left: 50%;
  transform: translateX(-50%);

  width: 125px;
  height: 150px;
  margin-top: -190px;

  /* 初始位置（固定为 1920 画布下的位置） */
  margin-left: -495px;

  transition: margin-left 0.3s ease;
}

/* 左右箭头：以中心为锚点设置固定偏移（原 310/1530 相对中心 960） */
.future_arrow_left{
  position: absolute;
  left: 50%;
  width: 20px;
  height: 20px;
  background-image: url('../assets/future/left.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: -650px;
  margin-top: -178px;
  z-index: 11;
}
.future_arrow_right{
  position: absolute;
  left: 50%;
  width: 20px;
  height: 20px;
  background-image: url('../assets/future/right.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  margin-left: 570px;
  margin-top: -178px;
  z-index: 11;
}

/* 禁止时间轴文本/标记被双击选中 */
.future_title2,
.future_content,
.timeline_date,
.timeline_marker {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 新增：箭头禁用态样式 */
.future_arrow_left.disabled,
.future_arrow_right.disabled {
  opacity: 0.35;
  pointer-events: none;
  cursor: default;
}

/* 小屏下：仍以 1920 画布为基准，避免重排导致偏移 */
@media (max-width: 768px) {
  .future_container {
    position: relative;
    width: 1920px;
    max-width: 1920px;
    min-width: 1920px;
    left: 50%;
    transform: translateX(-960px);
    margin: 100px 0 0;
  }

  /* 关键：不要把以下元素改为 position: static
     保持它们在 1920 画布上的绝对定位与像素偏移
     如需额外调整，可在这里增加微调，但不要覆盖原定位 */
  /* .future_title2,
     .future_content,
     .line,
     .future_picture,
     .future_timeline,
     .timeline_marker,
     .timeline_date,
     .timeline_marker1_container,
     .future_arrow_left,
     .future_arrow_right { } */
}
  .BITdonate {
    //background-image: url('../assets/background/BITdonate.jpg');
    height: 420px;
    padding: 0 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    min-width: 600px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  

  /* 左侧图片 */
  .BITplan-image {
    max-width: 55%;
    margin-right: 5%;
    margin-left: 20%; /* 增加左边距使图片向右移动 */
  }

  .BITplan-image img {
    max-width: 110%; /* 图片缩小至90% */
    height: 537.6px;
    margin-top: -120px; /* 图片再下移一小段距离 */
  }

  .BITdonate-content {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    justify-content: center;
    padding-top: -50px;
  }

  /* 右侧标题样式 */
  .BITdonate-title {
    font-family: "微软雅黑", 'Arial', sans-serif;
    color: #ece6e6;
    font-size: 44px;
    font-weight: 450;
    line-height: 1.2;
    margin-bottom: 10px;
    margin-left: -150px; /* 文字左移 */
  }

  /* 右侧副标题样式 */
  .title2 {
    font-family: "微软雅黑", 'Arial', sans-serif;
    color: #ece6e6;
    font-size: 28px;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 10px;
    margin-left: -145px; /* 文字左移 */
  }

  /* 右侧内容样式 */
  .content3 {
    background-image: url('../assets/background/BITplanground.png');
    background-size: 100% 100%; /* 保持图片位置不变 */
    background-position: center;
    background-repeat: no-repeat;
    font-family: "微软雅黑", 'Arial', sans-serif;
    color: #ece6e6;
    font-size: 20px;
    font-weight: 200;
    line-height: 1.2;
    margin-bottom: 18px;
    margin-left: -150px; /* 文字右移（减少左负边距） */
    max-width: 500px;
    min-height: 120px; /* 设置最小高度以确保有足够空间居中 */
    display: flex;
    align-items: center;
    padding-left: 30px; /* 仅通过padding-left移动文字内容，不影响背景图片位置 */
  }
  .content4 {
    font-family: "微软雅黑", 'Arial', sans-serif;
    color: #ece6e6;
    font-size: 30px;
    font-weight: 400;
    line-height: 1.2;
    margin-left: -145px; /* 文字左移 */
  
  }
}
  .RWAcooperate {
    //background-image: url('../assets/background/RWAcooperate.jpg');
    

    height: 575px;
   
   
    margin-bottom: 30px;
    

    
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
    max-width: 1920px;
    min-width: 1920px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

   




  
    .title {
     font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0px;
      font-family: 'Arial', sans-serif;
    
      text-align: center;
      width: 100%;
    }
    
    .image-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 60px;
      width: 70%;
      max-width: 1200px;
      margin-top: 60px;
    }
    
    .grid-image {
      width: 100%;
      height: 100px;
      object-fit: cover;
      border-radius: 8px;
      transition: transform 0.3s ease;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    
    .grid-image:hover {
       transform: none;
      }
  }



.manifesto {
  margin-top: 30px;

  img {
    width: 100%;
  }

 

  /* 投票排行榜滚动条样式 */
  
}


</style>
